import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Layout_action_menus extends PureComponent {
  render() {
    return (
      <div className="row" id="layout_action_menus">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Layout Action Menus</h2>
              <p>
                Layout action menus are a great way to add additional custom
                functionality to the record edit page. Action menu buttons
                support the on_click_eval property which allows you to use the
                NL library to manipulate the record change fields in the
                database create user notifications or even send text messages.
                For more information have a look at the Nexoid Library (NL)
                Overview page under Workflow.
              </p>

              <h3>Compatibility</h3>
              <table style={{ width: "auto" }}>
                <tbody>
                  <tr>
                    <td className="b top">Page</td>
                    <td className="b top">Support</td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Dashboard
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Record
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold"
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Report
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Search
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold"
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">color</td>
                    <td>Icon color.</td>
                  </tr>
                  <tr>
                    <td className="b">function_link</td>
                    <td>
                      Function links allow you to connect your action buttons to
                      more complex prebuilt component functions like open
                      attachments dialogue window.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon</td>
                    <td>Icon selected from the material icon font.</td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>Text displayed in the menu.</td>
                  </tr>
                  <tr>
                    <td className="b">on_click_eval</td>
                    <td>
                      Allows you to insert javascript code at the client level
                      when the button is clicked.
                      <br />
                      <i>"console.log('A change happend.')"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      Order that the datasets will appear in the group.
                      <br />
                      <i>1 - 10000 default is the order of the model</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">permission</td>
                    <td>Only show if user has permission.</td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Layout Example</h2>
            </section>
            <section>
              <h3>Example:</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"notes"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Notes"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"description"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">"console.log('NL Library', NL)"</span>
                  ,
                </div>
                <div className="i2">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"attachments"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Attachments"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"icon"</span>:{" "}
                  <span className="jsonY">"attachment"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"color"</span>:{" "}
                  <span className="jsonY">"#1976D2"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"function_link"</span>:{" "}
                  <span className="jsonY">"showAttachments"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"permission"</span>:{" "}
                  <span className="jsonY">"incident|FileDownload"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout_action_menus;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Layout_action_menus.js